<template>
  <div class="store-management-container">
    <!-- 功能区 -->
    <div class="action-bar">
      <div class="search-section">
        <el-input
          v-model="searchKeyword"
          placeholder="请输入门店名称或地址"
          clearable
          @clear="handleSearch"
          @keyup.enter.native="handleSearch"
          class="search-input"
        >
          <el-button slot="append" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </el-input>
        
        <el-button 
          type="primary" 
          icon="el-icon-plus" 
          @click="openAddDialog"
          style="margin-left:30px"
        >
          新增门店
        </el-button>
      </div>
    </div>
    
    <!-- 数据表格 -->
    <div class="data-table">
      <el-table
        :data="filteredStores"
        stripe
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{background:'#f5f7fa', fontWeight: 'bold'}"
      >
        <el-table-column prop="id" label="ID" width="100" sortable align="center">
          <template slot-scope="scope">
            <span class="id-cell">#{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        
        <el-table-column prop="name" label="门店名称" width="250" align="center">
          <template slot="header">
            <div class="flex-center">
              <i class="el-icon-shop"></i>
              <span>门店名称</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column prop="address" label="门店地址" min-width="350" align="center">
          <template slot="header">
            <div class="flex-center">
              <i class="el-icon-location"></i>
              <span>门店地址</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column prop="businessHours" label="营业时间" width="200" align="center">
          <template slot="header">
            <div class="flex-center">
              <i class="el-icon-time"></i>
              <span>营业时间</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="220" fixed="right" align="center">
          <template slot="header">
            <div class="flex-center">
              <i class="el-icon-setting"></i>
              <span>操作</span>
            </div>
          </template>
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-edit"
              @click="openEditDialog(scope.row)"
            >编辑</el-button>
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              @click="deleteStore(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <!-- 新增/编辑门店对话框 -->
    <el-dialog 
      :title="dialogType === 'add' ? '新增门店' : '编辑门店信息'"
      :visible.sync="storeDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      center
      @closed="resetForm"
    >
      <el-form 
        :model="storeForm" 
        :rules="formRules" 
        ref="storeForm"
        label-width="120px"
        label-position="right"
      >
        <el-form-item label="门店名称" prop="name">
          <el-input 
            v-model="storeForm.name" 
            placeholder="请输入门店名称"
            clearable
          ></el-input>
        </el-form-item>
        
        <el-form-item label="门店地址" prop="address">
          <el-input 
            v-model="storeForm.address" 
            placeholder="请输入门店地址"
            clearable
          ></el-input>
        </el-form-item>
        
        <el-form-item label="营业时间" prop="businessHours">
          <el-select 
            v-model="storeForm.businessHours" 
            filterable
            allow-create
            placeholder="请选择或输入营业时间"
            style="width: 100%"
          >
            <el-option
              v-for="time in businessTimeOptions"
              :key="time"
              :label="time"
              :value="time"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="storeDialogVisible = false">取 消</el-button>
        <el-button 
          type="primary" 
          @click="submitStoreForm"
        >
          {{ dialogType === 'add' ? '确 定 添 加' : '保 存 修 改' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {createShop, updateShop, getShops, deleteShop} from '../api/admin'

export default {
  name: 'StoreManagement',
  data() {
    return {
      searchKeyword: '',
      loading: false,
      stores: [],
      // 营业时间选项
      businessTimeOptions: [
        '周一至周日: 9:00-21:00',
        '周一至周日: 08:00-18:00',
        '周一至周日: 10:00-22:00',
        '周一至周日: 08:30-17:30',
        '周一至周日: 09:30-20:30',
        '周一至周日: 24小时营业',
      ],
      storeDialogVisible: false,
      dialogType: 'add', // 'add' 或 'edit'
      storeForm: {
        id: null,
        name: '',
        address: '',
        businessHours: ''
      },
      formRules: {
        name: [
          { required: true, message: '门店名称不能为空', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在2到20个字符', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '门店地址不能为空', trigger: 'blur' }
        ],
        businessHours: [
          { required: true, message: '营业时间不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    filteredStores() {
      if (!this.searchKeyword) {
        return this.stores;
      }
      const keyword = this.searchKeyword.toLowerCase();
      return this.stores.filter(store => {
        return (
          String(store.id).includes(keyword) ||
          store.name.toLowerCase().includes(keyword) ||
          store.address.toLowerCase().includes(keyword)
        );
      });
    }
  },
  mounted(){
    //this.refreshStores()
    //this.testImport()
    this.refreshStores()
  },
  methods: {
    handleSearch() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 300);
    },

    refreshStores(){
        this.loading = true
        getShops().then(res => {
            if(res.code == 1)
            {
                this.stores = []
                res.data.forEach(element => {
                    this.stores.push({
                        id:element.ID,
                        name: element.ShopName,
                        address: element.ShopAddress,
                        businessHours:element.BusinessHours
                    })
                });
            }
        }).catch(err=>{
            console.log(err)
        }).finally(this.loading = false)    
    },
    
    openAddDialog() {
      this.dialogType = 'add';
      this.storeDialogVisible = true;
    },
    
    openEditDialog(store) {
      this.dialogType = 'edit';
      this.storeForm = {
        id: store.id,
        name: store.name,
        address: store.address,
        businessHours: store.businessHours
      };
      this.storeDialogVisible = true;
    },
    
    submitStoreForm() {
      this.$refs.storeForm.validate(valid => {
        if (valid) {
          if (this.dialogType === 'add') {
            createShop({
                shop_name:this.storeForm.name,
                shop_address:this.storeForm.address,
                business_hours:this.storeForm.businessHours
            }).then(res=>{
                if(res.code == 1)
                {
                    this.$message.success(`门店 ${this.storeForm.name} 添加成功`);
                    this.refreshStores()
                }
            }).catch(err => {
                console.log(err)
            })
            
            
          } else {
            updateShop(this.storeForm.id, {
                shop_name:this.storeForm.name,
                shop_address:this.storeForm.address,
                business_hours:this.storeForm.businessHours
            }).then(res=>{
                if(res.code == 1)
                {
                    this.$message.success(`门店 ${this.storeForm.name} 信息更新成功`);
                    this.refreshStores()
                }
            }).catch(err => {
                console.log(err)
            })
          }
          this.storeDialogVisible = false;
        }
      });
    },
    
    deleteStore(store) {
      this.$confirm(`确定要删除门店 "${store.name}" 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteShop(store.id).then(res=>{
            if(res.code == 1)
            {
                this.$message.success('删除成功');
            }
            this.refreshStores()
        })
        
      }).catch(() => {
        this.$message.info('操作已取消');
      });
    },
    
    resetForm() {
      this.storeForm = {
        id: null,
        name: '',
        address: '',
        businessHours: ''
      };
      if (this.$refs.storeForm) {
        this.$refs.storeForm.resetFields();
      }
    },
  }
}
</script>

<style scoped>
.store-management-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.action-bar {
  background-color: white;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.action-bar .search-section {
  display: flex;
  align-items: center;
}

.action-bar .search-section .search-input {
  width: 350px;
}

.data-table {
  background-color: white;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  flex: 1;
  min-height: 400px;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.id-cell {
  font-weight: bold;
  color: #409eff;
}

.dialog-footer {
  text-align: center;
}
</style>